import React, { memo, useCallback, useState } from 'react';
import { EditIcon } from '@ui/components';
import { Modal, notification } from 'antd';
import { deleteContentManager, IContentManager } from '@ui/api/v2/user.api';

interface IProps {
  manager: IContentManager;
  setEditManager: (manager: IContentManager) => void;
  onDelete: (id: number) => void;
}

function ContentManagerCard({ manager, setEditManager, onDelete }: IProps) {
  const [showModal, setShowModal] = useState(false);

  const onEditClick = useCallback(() => {
    setEditManager(manager);
  }, [manager, setEditManager]);

  const deleteManager = useCallback(async () => {
    setShowModal(false);
    const { error } = await deleteContentManager(manager.id);
    if (error) {
      notification.error({
        message: error.response.data.message,
      });
    } else {
      onDelete(manager.id);
    }
  }, [manager.id, onDelete, setShowModal]);

  return (
    <div className="content__item">
      <span>{manager.login}</span>
      <span>
        {manager.lastName} {manager.firstName} {manager.middleName}
      </span>
      <span>{manager.idLotus}</span>
      <div className="content__controls">
        <EditIcon onClick={onEditClick} type="edit" />
        <EditIcon onClick={() => setShowModal(true)} type="remove" />
      </div>
      <Modal
        okButtonProps={{
          style: {
            width: '120px',
          },
          size: 'large',
          type: 'danger',
        }}
        cancelButtonProps={{
          style: {
            width: '120px',
          },
          size: 'large',
          type: 'primary',
        }}
        okText="Да"
        cancelText="Нет"
        title="Удаление города"
        visible={showModal}
        onOk={deleteManager}
        onCancel={() => setShowModal(false)}
      >
        <p>Вы уверены, что ходите удалить город {manager.login}</p>
      </Modal>
    </div>
  );
}

export default memo(ContentManagerCard);



// WEBPACK FOOTER //
// ./src/components/ContentManagers/ContentManagerCard.tsx